'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Get all the values from an object
 * @param {Object} obj
 * @return {Object[]} values
 */
var values = exports.values = function values(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
};

var parseUrlTests = exports.parseUrlTests = function parseUrlTests() {
  var tests = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

  if (!Array.isArray(tests)) return [];
  var urlTests = tests.reduce(function (acc, test) {
    if (test.type === 'url') {
      acc.push(test);
    }
    return acc;
  }, []);
  return urlTests;
};